/* Equipery page-scroll RGB cable - standalone module. */
(function () {
  'use strict';

  var SVGNS = 'http://www.w3.org/2000/svg';

  /* Sampled from the product photo, pushed up in saturation so they keep their
     identity against a white page. No whites, no pastels: on white those read
     as nothing at all. */
  var PALETTE = ['#1b3bff', '#ff1f3d', '#17d14a', '#12c8ff', '#ff29c3'];

  function num(v, d) {
    var f = parseFloat(v);
    return isNaN(f) ? d : f;
  }

  function pct(v, d) {
    return Math.max(0, Math.min(100, num(v, d))) / 100;
  }

  function Progress(host) {
    this.host = host;
    this.dead = false;
    this.ticking = false;
    this.leds = [];
    this.litIndex = -1;
    this.visible = null;
    this.lampOn = null;
    this.head = null;
    this.resizeTimer = null;
    this.reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    var a = function (k) { return host.getAttribute(k); };

    this.o = {
      onDesktop: a('data-eq-progress-desktop') === 'true',
      onMobile: a('data-eq-progress-mobile') === 'true',
      at: Math.max(0, num(a('data-progress-at'), 150)),
      /* the share of the page over which the strip fills: 0.6 means it is
         fully lit by the time the visitor is 60% down */
      fullAt: Math.max(0.05, Math.min(1, num(a('data-progress-full-at'), 100) / 100)),
      sideDesktop: a('data-progress-side-desktop') === 'right' ? 'right' : 'left',
      sideMobile: a('data-progress-side-mobile') === 'right' ? 'right' : 'left',
      top: Math.max(0, num(a('data-progress-top'), 12)),
      right: Math.max(0, num(a('data-progress-right'), 12)),
      bottom: Math.max(0, num(a('data-progress-bottom'), 12)),
      left: Math.max(0, num(a('data-progress-left'), 12)),
      topM: Math.max(0, num(a('data-progress-top-mobile'), 8)),
      rightM: Math.max(0, num(a('data-progress-right-mobile'), 8)),
      bottomM: Math.max(0, num(a('data-progress-bottom-mobile'), 8)),
      leftM: Math.max(0, num(a('data-progress-left-mobile'), 8)),
      fade: Math.max(0, num(a('data-progress-fade'), 250)),
      showLamp: a('data-progress-show-lamp') !== 'false',
      lampDesktop: Math.max(20, num(a('data-progress-lamp-desktop'), 56)),
      lampMobile: Math.max(20, num(a('data-progress-lamp-mobile'), 46)),
      lampSrc: a('data-lamp-src') || '',
      rotationPx: Math.max(400, num(a('data-rotation-px'), 2800)),
      hideUnlit: a('data-progress-hide-unlit') === 'true',
      wireColor: a('data-progress-track-color') || '#aab3bd',
      wireWidth: Math.max(0.4, num(a('data-progress-track-width'), 1.2)),
      wireOp: pct(a('data-progress-track-opacity'), 28),
      ledColor: a('data-progress-led-color') || '',
      ledRgb: a('data-progress-led-rgb') !== 'false',
      ledSize: Math.max(0.6, num(a('data-progress-led-size'), 2.4)),
      ledSpacing: Math.max(6, num(a('data-progress-led-spacing'), 15)),
      ledOp: pct(a('data-progress-led-opacity'), 100),
      glowScale: Math.max(1.5, num(a('data-progress-led-glow-size'), 420) / 100),
      glowOp: pct(a('data-progress-led-glow-opacity'), 55)
    };

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.frame = this.frame.bind(this);

    if (this.enabledNow()) this.mount();
  }

  Progress.prototype.isMobile = function () {
    return document.documentElement.clientWidth < 750;
  };

  Progress.prototype.enabledNow = function () {
    return this.isMobile() ? this.o.onMobile : this.o.onDesktop;
  };

  Progress.prototype.insets = function () {
    var m = this.isMobile();
    return {
      top: m ? this.o.topM : this.o.top,
      right: m ? this.o.rightM : this.o.right,
      bottom: m ? this.o.bottomM : this.o.bottom,
      left: m ? this.o.leftM : this.o.left
    };
  };

  Progress.prototype.headerEl = function () {
    return document.querySelector('header.header') ||
      document.querySelector('.shopify-section-group-header-group') ||
      document.querySelector('header');
  };

  /* The header lamp belongs to the other module. We only read its box. */
  Progress.prototype.headerLampRect = function () {
    var el = document.querySelector('.eq-sl-lamp-anchor');
    if (!el) return null;
    var r = el.getBoundingClientRect();
    if (!r.width || r.bottom <= 0) return null;
    return r;
  };

  Progress.prototype.headerHidden = function () {
    var h = this.headerEl();
    if (!h) return true;
    var cs = window.getComputedStyle(h);
    if (cs.display === 'none' || cs.visibility === 'hidden') return true;
    var r = h.getBoundingClientRect();
    return r.height > 1 && r.bottom <= 1;
  };

  Progress.prototype.gradient = function (defs, id, color) {
    var rg = document.createElementNS(SVGNS, 'radialGradient');
    rg.setAttribute('id', id);
    /* saturated centre, soft colour bloom, clean fade - reads as light on white */
    var stops = [['0%', '0.95'], ['30%', '0.55'], ['62%', '0.18'], ['100%', '0']];
    for (var i = 0; i < stops.length; i++) {
      var s = document.createElementNS(SVGNS, 'stop');
      s.setAttribute('offset', stops[i][0]);
      s.setAttribute('stop-color', color);
      s.setAttribute('stop-opacity', stops[i][1]);
      rg.appendChild(s);
    }
    defs.appendChild(rg);
  };

  Progress.prototype.mount = function () {
    var wrap = document.createElement('div');
    wrap.className = 'eq-pp';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.setAttribute('role', 'presentation');
    wrap.style.setProperty('--eq-pp-fade', this.o.fade + 'ms');
    wrap.style.setProperty('--eq-pp-wire-op', this.o.hideUnlit ? '0' : this.o.wireOp.toFixed(3));
    wrap.style.setProperty('--eq-pp-lit-op', Math.min(1, this.o.wireOp * 2.4).toFixed(3));
    wrap.style.setProperty('--eq-pp-led-op', this.o.ledOp.toFixed(3));
    wrap.style.setProperty('--eq-pp-glow-op', this.o.glowOp.toFixed(3));
    document.body.appendChild(wrap);
    this.wrap = wrap;

    if (this.o.showLamp && this.o.lampSrc) {
      var lamp = document.createElement('img');
      lamp.className = 'eq-pp__lamp';
      lamp.setAttribute('alt', '');
      lamp.setAttribute('aria-hidden', 'true');
      lamp.setAttribute('decoding', 'async');
      lamp.src = this.o.lampSrc;
      wrap.appendChild(lamp);
      this.lamp = lamp;
    }

    this.build();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    window.addEventListener('load', this.onResize, { passive: true });

    if ('ResizeObserver' in window) {
      var self = this;
      this.ro = new ResizeObserver(function () { self.onResize(); });
      this.ro.observe(document.body);
    }
  };

  Progress.prototype.build = function () {
    if (this.dead || !this.wrap) return;

    var wrap = this.wrap;
    if (this.svg && this.svg.parentNode) this.svg.parentNode.removeChild(this.svg);

    var W = document.documentElement.clientWidth;
    var H = window.innerHeight;
    var inset = this.insets();
    var mobile = this.isMobile();
    var lampSize = mobile ? this.o.lampMobile : this.o.lampDesktop;
    var side = mobile ? this.o.sideMobile : this.o.sideDesktop;

    this.W = W;
    this.H = H;
    this.side = side;
    this.lampSize = lampSize;
    if (this.lamp) this.lamp.style.setProperty('--eq-pp-lamp', lampSize + 'px');

    /* The rail sits exactly at the spacing value, independent of the product
       size, so a 2px inset really does hug the screen edge. */
    var half = this.o.wireWidth * 0.6;
    var railX = side === 'right' ? W - inset.right - half : inset.left + half;
    var railTop = inset.top + lampSize;
    var railBottom = H - inset.bottom;
    if (railBottom - railTop < 60) railTop = Math.max(inset.top, railBottom - 60);

    this.railX = railX;
    this.railTop = railTop;
    this.railBottom = railBottom;
    this.railLen = railBottom - railTop;

    /* the product is kept fully on screen even when the rail hugs the edge */
    var halfLamp = lampSize / 2;
    this.dockCx = Math.min(Math.max(railX, halfLamp + 2), W - halfLamp - 2);
    this.dockCy = inset.top + halfLamp;

    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('class', 'eq-pp__svg');
    svg.setAttribute('width', W);
    svg.setAttribute('height', H);
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('aria-hidden', 'true');

    var defs = document.createElementNS(SVGNS, 'defs');
    for (var g = 0; g < PALETTE.length; g++) this.gradient(defs, 'eqPpGlow' + g, PALETTE[g]);
    if (this.o.ledColor) this.gradient(defs, 'eqPpGlowSolid', this.o.ledColor);

    var lg = document.createElementNS(SVGNS, 'linearGradient');
    lg.setAttribute('id', 'eqPpWire');
    lg.setAttribute('x1', '0');
    lg.setAttribute('y1', '0');
    lg.setAttribute('x2', '0');
    lg.setAttribute('y2', '1');
    for (var s = 0; s < PALETTE.length; s++) {
      var st = document.createElementNS(SVGNS, 'stop');
      st.setAttribute('offset', (s / (PALETTE.length - 1) * 100).toFixed(0) + '%');
      st.setAttribute('stop-color', this.o.ledRgb ? PALETTE[s] : (this.o.ledColor || PALETTE[0]));
      lg.appendChild(st);
    }
    defs.appendChild(lg);
    svg.appendChild(defs);

    /* lead = hanging piece between the product and the rail, redrawn each frame */
    var lead = document.createElementNS(SVGNS, 'path');
    lead.setAttribute('class', 'eq-pp__wire eq-pp__wire--lit');
    lead.setAttribute('stroke', this.o.wireColor);
    lead.setAttribute('stroke-width', this.o.wireWidth.toFixed(2));
    svg.appendChild(lead);
    this.lead = lead;

    var railD = 'M ' + railX.toFixed(1) + ' ' + railTop.toFixed(1) +
      ' L ' + railX.toFixed(1) + ' ' + railBottom.toFixed(1);

    var dim = document.createElementNS(SVGNS, 'path');
    dim.setAttribute('class', 'eq-pp__wire eq-pp__wire--dim');
    dim.setAttribute('d', railD);
    dim.setAttribute('stroke', this.o.wireColor);
    dim.setAttribute('stroke-width', this.o.wireWidth.toFixed(2));
    if (this.o.hideUnlit) dim.setAttribute('stroke-opacity', '0');
    svg.appendChild(dim);

    var lit = document.createElementNS(SVGNS, 'path');
    lit.setAttribute('class', 'eq-pp__wire eq-pp__wire--lit');
    lit.setAttribute('d', railD);
    lit.setAttribute('stroke', 'url(#eqPpWire)');
    lit.setAttribute('stroke-width', (this.o.wireWidth * 1.2).toFixed(2));
    lit.style.strokeDasharray = this.railLen;
    lit.style.strokeDashoffset = this.railLen;
    svg.appendChild(lit);
    this.lit = lit;

    var group = document.createElementNS(SVGNS, 'g');
    var spacing = this.o.ledSpacing;
    var count = Math.floor(this.railLen / spacing);
    if (count > 260) { count = 260; spacing = this.railLen / count; }

    var coreR = this.o.ledSize;
    var bloomR = coreR * this.o.glowScale;

    this.leds = [];
    this.litIndex = -1;

    for (var i = 0; i <= count; i++) {
      var pos = i * spacing;
      var slot = i % PALETTE.length;
      var color = this.o.ledRgb ? PALETTE[slot] : (this.o.ledColor || PALETTE[0]);
      var glowId = this.o.ledRgb ? 'eqPpGlow' + slot : (this.o.ledColor ? 'eqPpGlowSolid' : 'eqPpGlow0');

      var led = document.createElementNS(SVGNS, 'g');
      led.setAttribute('class', 'eq-pp__led');
      led.setAttribute('transform', 'translate(' + railX.toFixed(1) + ',' + (railTop + pos).toFixed(1) + ')');

      var bloom = document.createElementNS(SVGNS, 'circle');
      bloom.setAttribute('class', 'eq-pp__led-bloom');
      bloom.setAttribute('r', bloomR.toFixed(2));
      bloom.setAttribute('fill', 'url(#' + glowId + ')');
      led.appendChild(bloom);

      var core = document.createElementNS(SVGNS, 'circle');
      core.setAttribute('class', 'eq-pp__led-core');
      core.setAttribute('r', coreR.toFixed(2));
      core.setAttribute('fill', color);
      led.appendChild(core);

      group.appendChild(led);
      this.leds.push({ el: led, pos: pos });
    }
    svg.appendChild(group);

    wrap.insertBefore(svg, wrap.firstChild);
    this.svg = svg;

    this.head = null;
    this.frame();
  };

  Progress.prototype.onScroll = function () {
    if (this.ticking || this.dead) return;
    this.ticking = true;
    window.requestAnimationFrame(this.frame);
  };

  Progress.prototype.onResize = function () {
    if (this.dead) return;
    var self = this;
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(function () {
      if (self.dead) return;
      var W = document.documentElement.clientWidth;
      var H = window.innerHeight;
      if (W === self.W && Math.abs(H - self.H) < 20) { self.frame(); return; }
      self.build();
    }, 160);
  };

  Progress.prototype.frame = function () {
    this.ticking = false;
    if (this.dead || !this.svg) return;

    var y = window.pageYOffset || document.documentElement.scrollTop || 0;

    var show = y >= this.o.at;
    if (show !== this.visible) {
      this.visible = show;
      if (show) this.wrap.classList.add('is-visible');
      else this.wrap.classList.remove('is-visible');
    }

    var docH = Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0);
    var maxScroll = Math.max(1, docH - window.innerHeight);

    /* the strip completes at fullAt of the page, then stays full */
    var ratio = (y / maxScroll) / this.o.fullAt;
    if (ratio < 0) ratio = 0;
    if (ratio > 1) ratio = 1;

    var front = this.railLen * ratio;
    this.lit.style.strokeDashoffset = (this.railLen - front).toFixed(2);

    var leds = this.leds;
    while (this.litIndex + 1 < leds.length && leds[this.litIndex + 1].pos <= front) {
      this.litIndex++;
      leds[this.litIndex].el.classList.add('is-lit');
    }
    while (this.litIndex >= 0 && leds[this.litIndex].pos > front) {
      leds[this.litIndex].el.classList.remove('is-lit');
      this.litIndex--;
    }

    /* where the cable hangs from: header lamp while it is on screen, docked
       lamp once the header is gone */
    var hidden = this.headerHidden();
    var hr = hidden ? null : this.headerLampRect();
    var tx, ty;

    if (hr) {
      tx = hr.left + hr.width * 0.5;
      ty = hr.top + hr.height * 0.62;
    } else {
      tx = this.dockCx;
      ty = this.dockCy + this.lampSize * 0.34;
    }

    /* glide instead of jumping, so the swap between the two products reads as
       one cable being carried across */
    if (!this.head) this.head = { x: tx, y: ty };
    else {
      var k = this.reduced ? 1 : 0.18;
      this.head.x += (tx - this.head.x) * k;
      this.head.y += (ty - this.head.y) * k;
    }

    var hx = this.head.x;
    var hy = this.head.y;
    var dy = this.railTop - hy;
    this.lead.setAttribute('d',
      'M ' + hx.toFixed(1) + ' ' + hy.toFixed(1) +
      ' C ' + hx.toFixed(1) + ' ' + (hy + dy * 0.55).toFixed(1) +
      ' ' + this.railX.toFixed(1) + ' ' + (this.railTop - dy * 0.45).toFixed(1) +
      ' ' + this.railX.toFixed(1) + ' ' + this.railTop.toFixed(1));

    if (this.lamp) {
      var on = hidden && show;
      if (on !== this.lampOn) {
        this.lampOn = on;
        if (on) this.lamp.classList.add('is-on');
        else this.lamp.classList.remove('is-on');
      }
      var deg = this.reduced ? 0 : (y / this.o.rotationPx) * 360;
      this.lamp.style.left = (this.dockCx - this.lampSize / 2).toFixed(1) + 'px';
      this.lamp.style.top = (this.dockCy - this.lampSize / 2).toFixed(1) + 'px';
      this.lamp.style.transform = 'rotate(' + deg.toFixed(2) + 'deg)';
    }
  };

  Progress.prototype.destroy = function () {
    this.dead = true;
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('load', this.onResize);
    if (this.ro) this.ro.disconnect();
    if (this.resizeTimer) clearTimeout(this.resizeTimer);
    if (this.wrap && this.wrap.parentNode) this.wrap.parentNode.removeChild(this.wrap);
    this.wrap = null;
    this.svg = null;
    this.leds = [];
  };

  function boot() {
    var host = document.querySelector('[data-eq-string-light]');
    if (!host) return;

    if (window.__eqProgress) {
      window.__eqProgress.destroy();
      window.__eqProgress = null;
    }
    var stale = document.querySelectorAll('.eq-pp');
    for (var i = 0; i < stale.length; i++) {
      if (stale[i].parentNode) stale[i].parentNode.removeChild(stale[i]);
    }

    window.__eqProgress = new Progress(host);
  }

  window.__eqProgressBoot = boot;

  if (!window.__eqProgressBound) {
    window.__eqProgressBound = true;
    document.addEventListener('shopify:section:load', function () {
      window.requestAnimationFrame(function () {
        if (window.__eqProgressBoot) window.__eqProgressBoot();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
